
import React, { useState } from "react";

import { UserOverview, LocationInformation, UserInformation } from "./ModalState";

import "./userModal.css";
import {
    userModalType,
} from "../../features/editAndView/ViewAndEditType";
import ViewAndEditModal from "../viewAndEditModal/ViewAndEditModal";
import { updateUser } from "../../services/userService";
import { userModalFormType } from "./userModalType";
import { TranslationEnum, usePortalTranslation } from "../../providers/TranslationProvider";
const WDModal = ({
    modelData,
    close,
    setGenericMetaData,
    getTableRows,
}: userModalType) => {
    // console.log("modelData", modelData);
    const { translate } = usePortalTranslation();
    const CUR_COMPONENT_COMMON="commonPortal";
    const [activeButton, setActiveButton] = useState(0);

    const [check, setCheck] = useState(false);
  
    const [validEmail, setValidEmail] = useState(true);
  
    const [validMobile, setValidMobile] = useState(true);
  
    const [editRequestBody, setEditRequestBody] = useState<userModalFormType>({
      loginId: modelData.loginId,
    });
    const [defaultInputs, setDefaultInputs] = useState<userModalFormType>(modelData);

    const uploadEditRecord = async () => {
        try {
            if (editRequestBody && validEmail && validMobile && check) {
              const response = await updateUser({
                ...editRequestBody,
              });
      
              if (response.status === 200) {
                setGenericMetaData(translate(TranslationEnum.common_portal,"Successfully updated the data"), "Success", true);
              } else {
                throw new Error();
              }
            }
          } catch (error) {
            setGenericMetaData(
              "Some Error occured while Updating the Data",
              "Error",
              true
            );
          }
          close();
      };

    const changeModalStateWD = (activeButton: number) => {
        switch (activeButton) {
            case 0:
                return (
                    <UserInformation
                        userInputs={{ defaultInputs,setDefaultInputs}}
                        requestBody={{ editRequestBody, setEditRequestBody }}
                        submit={{ check, setCheck }}
                    />
                );
            case 1:
                return (
                    <LocationInformation
                        userInputs={{ defaultInputs,setDefaultInputs }}
                    />
                );
            default:
                return (
                    <UserInformation
                        userInputs={{ defaultInputs,setDefaultInputs}}
                        requestBody={{ editRequestBody, setEditRequestBody }}
                    />
                );
        }
    };

    return (
        <ViewAndEditModal
            closeModal={close}
            message={translate(TranslationEnum.common_portal,"Edit a record")}
            updateMethod={uploadEditRecord}
            check={check}
        >
            <div className="modal-content">
                <div className="modal-states">
                    <button
                        onClick={() => {
                            setActiveButton(0);
                        }}
                        className={
                            activeButton === 0
                                ? "active-model-button model-button"
                                : "model-button"
                        }
                    >
                        User Information
                    </button>
                    <button
                        onClick={() => {
                            setActiveButton(1);
                        }}
                        className={
                            activeButton === 1
                                ? "active-model-button model-button"
                                : "model-button"
                        }
                    >
                        Location Information
                    </button>
                </div>
                {changeModalStateWD(activeButton)}
            </div>
        </ViewAndEditModal>
    );
};

export default WDModal;
